<script lang="ts">

    export let title: string;

    var host = window.location.origin;

    let src = `${host}/images/file-plus-trimmed.png`;
    export function handleMouseOver() {
		src = `${host}/images/file-plus-trimmed-hover.png`;
	}
	export function handleMouseOut() {
		src = `${host}/images/file-plus-trimmed.png`;
	}
</script>

<div class="offerItem">

    <img class="addItem" {src} alt="file add icon" />

    <p class="offerTitle">{title}</p>
</div>

<style>
.offerItem{
    display: flex; 
    margin-bottom: 0.5rem; 
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    padding-top: 10px;
    padding-bottom: 10px;
    max-width: 84px;
    border-radius: 5px;
}
.offerTitle{
    text-align: center;
    max-width: 84px;
}
.addItem{
    max-width: 67.5px; /*84px;*/
    max-height: fit-content;
}
</style>